import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, combineLatest, isObservable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryEntryEditInfo } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';

import { DirectoryStructureSelectors } from 'src/app/store/samwin/directory/directory-structure/directory-structure.selectors';

@Pipe({
   name: 'directoryColumnComparator',
})
export class DirectoryColumnComparatorPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(directoryColumn: DirectoryColumn, directoryColumnEditInfo: DirectoryEntryEditInfo | Observable<DirectoryEntryEditInfo>) {
      let directoryColumnEntry$: Observable<DirectoryEntryEditInfo>;
      if (isObservable(directoryColumnEditInfo)) {
         directoryColumnEntry$ = directoryColumnEditInfo;
      } else {
         directoryColumnEntry$ = of(directoryColumnEditInfo);
      }
      const isEntryUpdated$ = combineLatest([this.store.select(DirectoryStructureSelectors.getColumnInstance), directoryColumnEntry$])
         .pipe(switchMap(([getColumnInstance, directoryEntryInfo]) => of(getColumnInstance(directoryEntryInfo?.updatedEntry, directoryColumn))))
         .pipe(map((entry) => !_.isNil(entry?.value)));
      const originalEntry$ = combineLatest([this.store.select(DirectoryStructureSelectors.getColumnInstance), directoryColumnEntry$])
         .pipe(switchMap(([getColumnInstance, directoryEntryInfo]) => of(getColumnInstance(directoryEntryInfo?.originalEntry, directoryColumn))))
         .pipe(
            map((entry) => {
               if (entry?.isValueSet) {
                  return entry.value;
               }
               return '';
            })
         );
      const editedEntry$ = combineLatest([this.store.select(DirectoryStructureSelectors.getColumnInstance), directoryColumnEntry$])
         .pipe(switchMap(([getColumnInstance, directoryEntryInfo]) => of(getColumnInstance(directoryEntryInfo?.editedEntry, directoryColumn))))
         .pipe(
            map((entry) => {
               if (entry?.isValueSet) {
                  return entry.value;
               }
               return '';
            })
         );
      const updatedEntry$ = combineLatest([this.store.select(DirectoryStructureSelectors.getColumnInstance), directoryColumnEntry$])
         .pipe(switchMap(([getColumnInstance, directoryEntryInfo]) => of(getColumnInstance(directoryEntryInfo?.updatedEntry, directoryColumn))))
         .pipe(
            map((entry) => {
               if (entry?.isValueSet) {
                  return entry.value;
               }
               return '';
            })
         );
      return combineLatest([isEntryUpdated$, originalEntry$, editedEntry$, updatedEntry$]).pipe(
         map(([isEntryUpdated, originalEntry, editedEntry, updatedEntry]) => isEntryUpdated && originalEntry !== updatedEntry && editedEntry !== updatedEntry)
      );
   }
}
